import { Select, VStack, HStack, Box, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

const SelectSection = observer(() => {
  const { pageStore } = useStores();

  const selected = pageStore.selected_one_department;

  return (
    <HStack
      borderRadius="10px"
      bg="rgb(51, 51, 51)"
      spacing={2}
      padding="4px"
      align="center"
    >
      <Select
        width="200px"
        border="none"
        color="#EEEEEE"
        borderRadius="10px"
        fontWeight={600}
        fontSize="14px"
        placeholder="Не выбрано"
        value={selected || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedOneDepartment(selectedValue || "");
          pageStore.updateSelectedOneManager("");
        }}
      >
        {pageStore.all_departments
          ?.filter((item) => item?.name !== "")
          .map((item, index) => (
            <option
              key={index}
              value={item.name}
              style={{ background: "#0C0C0C", color: "#EEEEEE" }}
            >
              {item.name}
            </option>
          ))}
      </Select>
    </HStack>
  );
});

export default SelectSection;